<template>
  <div>
    <v-row class="justify-center">
      <v-col cols="6" sm="6" md="3" lg="3" xl="3" v-for="(aboutItem, index) in aboutLinks" :key="index">
        <template>
          <v-hover v-slot="{ hover }">
            <v-card
              rounded="xl"
              class="mx-auto"
              elevation="6"
            >
              <v-img
                :src=aboutItem.photoUrl
              >
                <v-expand-transition>
                  <div
                    v-if="hover"
                    :class=aboutItem.color
                    style="height: 100%; cursor: pointer;"
                    @click="handleRouter(aboutItem.funcName)"
                  >
                    <v-img
                      height="140"
                      contain
                      :src=aboutItem.personPhoto
                    ></v-img>
                    <span  v-if="!$vuetify.breakpoint.smAndDown" class="grey-blue--text text--darken-4 text-body-2 pa-2 mt-n4">{{ aboutItem.funcIntro }}</span>

                  </div>
                </v-expand-transition>
              </v-img>
              
            </v-card>
          </v-hover>
        </template>
      </v-col>
    </v-row>
  </div>
</template>

<script>


export default {
  name: 'YA_AboutProducts',
  components: {
  },
  data() {
    return {
      aboutLinks: [
        {
          'photoUrl': require("@/assets/AboutPic/pic_About_powerChat.png"),
          'color': 'd-flex flex-wrap transition-fast-in-fast-out v-card--reveal text-h2 white--text teal lighten-1',
          'personPhoto': require("@/assets/contentPic/pic_chat_mainPhoto.png"),
          'funcName': 'PowerChat',
          'funcIntro': this.$t('message.About_PowerChat'),
        },
        {
          'photoUrl': require("@/assets/AboutPic/pic_About_powerTelegram.png"),
          'color': 'd-flex flex-wrap transition-fast-in-fast-out v-card--reveal text-h2 white--text blue lighten-1',
          'personPhoto': require("@/assets/contentPic/pic_telegram_mainPhoto.png"),
          'funcName': 'PowerTelegram',
          'funcIntro': this.$t('message.About_PowerTelegram'),
        },
        // {
        //   'photoUrl': require("@/assets/AboutPic/pic_About_powerFile.png"),
        //   'color': 'd-flex flex-wrap transition-fast-in-fast-out v-card--reveal text-h2 white--text red darken-1',
        //   'personPhoto': require("@/assets/contentPic/pic_file_mainPhoto.png"),
        //   'funcName': 'PowerFile',
        //   'funcIntro': 'Chat with any PDF document from legal agreements to financial reports, PowerFile brings your documents to life.',
        // },
        {
          'photoUrl': require("@/assets/AboutPic/pic_About_powerWrite.png"),
          'color': 'd-flex flex-wrap transition-fast-in-fast-out v-card--reveal text-h2 white--text yellow darken-3',
          'personPhoto': require("@/assets/contentPic/pic_writer_mainPhoto.png"),
          'funcName': 'PowerWriter',
          'funcIntro': this.$t('message.About_PowerWriter'),
        },
        {
          'photoUrl': require("@/assets/AboutPic/pic_About_powerRewrite.png"),
          'color': 'd-flex flex-wrap transition-fast-in-fast-out v-card--reveal text-h2 white--text purple darken-1',
          'personPhoto': require("@/assets/contentPic/pic_rewrite_mainPhoto.png"),
          'funcName': 'PowerRewrite',
          'funcIntro': this.$t('message.About_PowerRewrite'),
        },
        {
          'photoUrl': require("@/assets/AboutPic/pic_About_powerSummarizer.png"),
          'color': 'd-flex flex-wrap transition-fast-in-fast-out v-card--reveal text-h2 white--text deep-purple darken-1',
          'personPhoto': require("@/assets/contentPic/pic_summarizer_mainPhoto.png"),
          'funcName': 'PowerSummarizer',
          'funcIntro': this.$t('message.About_PowerSummarizer'),
        },
        {
          'photoUrl': require("@/assets/AboutPic/pic_About_powerGrammar.png"),
          'color': 'd-flex flex-wrap transition-fast-in-fast-out v-card--reveal text-h2 white--text green darken-1',
          'personPhoto': require("@/assets/contentPic/pic_grammar_mainPhoto.png"),
          'funcName': 'PowerGrammarFix',
          'funcIntro': this.$t('message.About_PowerGrammarFix'),
        },
        {
          'photoUrl': require("@/assets/AboutPic/pic_About_powerTranslate.png"),
          'color': 'd-flex flex-wrap transition-fast-in-fast-out v-card--reveal text-h2 white--text cyan darken-1',
          'personPhoto': require("@/assets/contentPic/pic_translate_mainPhoto.png"),
          'funcName': 'PowerTranslate',
          'funcIntro': this.$t('message.About_PowerTranslate'),
        },
        {
          'photoUrl': require("@/assets/AboutPic/pic_About_powerCode.png"),
          'color': 'd-flex flex-wrap transition-fast-in-fast-out v-card--reveal text-h2 white--text grey darken-1',
          'personPhoto': require("@/assets/contentPic/pic_code_mainPhoto.png"),
          'funcName': 'PowerCodeExplainer',
          'funcIntro': this.$t('message.About_PowerCodeExplainer'),
        },
        {
          'photoUrl': require("@/assets/AboutPic/pic_About_powerImitate.png"),
          'color': 'd-flex flex-wrap transition-fast-in-fast-out v-card--reveal text-h2 white--text red darken-1',
          'personPhoto': require("@/assets/contentPic/pic_file_mainPhoto.png"),
          'funcName': 'PowerImitate',
          'funcIntro': this.$t('message.About_PowerImitate'),
        },
        {
          'photoUrl': require("@/assets/AboutPic/pic_About_powerFewShot.png"),
          'color': 'd-flex flex-wrap transition-fast-in-fast-out v-card--reveal text-h2 white--text indigo darken-1',
          'personPhoto': require("@/assets/contentPic/pic_fewshot_mainPhoto.png"),
          'funcName': 'PowerFewShot',
          'funcIntro': this.$t('message.About_PowerFewShot'),
        },
      ]
    }
  },
  watch: {
    '$i18n.locale': function(newLocale, oldLocale) {
      this.aboutLinks[0].funcIntro = this.$t('message.About_PowerChat')
      this.aboutLinks[1].funcIntro = this.$t('message.About_PowerTelegram')
      this.aboutLinks[2].funcIntro = this.$t('message.About_PowerWriter')
      this.aboutLinks[3].funcIntro = this.$t('message.About_PowerRewrite')
      this.aboutLinks[4].funcIntro = this.$t('message.About_PowerSummarizer')
      this.aboutLinks[5].funcIntro = this.$t('message.About_PowerGrammarFix')
      this.aboutLinks[6].funcIntro = this.$t('message.About_PowerTranslate')
      this.aboutLinks[7].funcIntro = this.$t('message.About_PowerCodeExplainer')
      this.aboutLinks[8].funcIntro = this.$t('message.About_PowerImitate')
      this.aboutLinks[9].funcIntro = this.$t('message.About_PowerFewShot')
    }
  },
  created() {

  },
  mounted() {
    
  },

  methods: {
    handleRouter(funcName) {
      if (this.$router.currentRoute.path !== '/' + funcName) {
        this.$router.push('/' + funcName);
      }
    }
  }

};
</script>

<style scoped>
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  position: absolute;
  width: 100%;
}
</style>